import classes from 'src/components/ProductDetail/ProductSwatch.scss';
import React from 'react';
import { Swatch } from 'src/components/ProductDetail/ProductSwatch';
import { swatchCss } from 'src/components/ProductDetail/utils/swatchData';

export const SwatchTitle: React.FC<{ swatch: Swatch }> = (props) => {
    const css = swatchCss(props.swatch.swatch_data);
    return (
        <p className={['h2', classes.inlineTitle].join(' ')}>
            <span className={classes.swatchesItemStandalone} style={css} />
            {props.swatch.title}
        </p>
    );
};
